'use client'
const isEthereumWallet = (wallet) => wallet.chain === 'EVM';

export { isEthereumWallet };
